import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Modal,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import IMAGES from "../../../../../../assets/images/images";
import { FunctionalModalStyle } from "../../../../../../common/constants/custom-style";
import { CustomerFetchDetails } from "../../../../../../domain/models/customer-database/customerFetchDetails";
import { CustomerDatabaseStore } from "../../../../../../store/main/CustomerDatabaseStore";

interface Props {
  open: boolean;
  handleClose: Function;
}

const MapCustomerModal: React.FC<Props> = ({ open, handleClose }) => {
  const { customerFetchedData, fetchCustomerData } = CustomerDatabaseStore();
  const { handleSubmit, control, setValue } = useForm<any>({
    mode: "onChange",
  });

  const [customerName, setCustomerName] = useState("");

  const handleChange = (event: SelectChangeEvent) => {
    setCustomerName(event.target.value as string);
  };

  return (
    <>
      <Modal open={open}>
        <Box sx={FunctionalModalStyle}>
          <Stack spacing={1}>
            <Typography
              textAlign="center"
              variant="h6"
              fontFamily="Segoe UI"
              fontWeight={600}
              color="#4D4D4D"
            >
              Map Customer
            </Typography>
            <Typography variant="subtitle2">Select Customer</Typography>
            <FormControl fullWidth>
              <Select value={customerName} onChange={handleChange} size="small">
                {customerFetchedData.map((data: CustomerFetchDetails) =>
                  data.firmNames.map((names) => (
                    <MenuItem value={names.name} key={names._id}>
                      {names.name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
            <Typography variant="subtitle2">Phone Number</Typography>
            <Controller
              name="name"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  disabled
                  value={value}
                  error={error && true}
                  helperText={error?.message}
                  onChange={onChange}
                />
              )}
              rules={{
                required: { value: true, message: "Field Required" },
              }}
            />
            <Typography variant="subtitle2">GSTIN</Typography>
            <Controller
              name="name"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  disabled
                  value={value}
                  error={error && true}
                  helperText={error?.message}
                  onChange={onChange}
                />
              )}
              rules={{
                required: { value: true, message: "Field Required" },
              }}
            />
            <Stack
              direction="row"
              gap={2}
              justifyContent="space-around"
              alignItems="center"
            >
              <Typography variant="subtitle2">Shop Image</Typography>
              <Typography variant="subtitle2">Invoice Image</Typography>
            </Stack>
            <Stack
              direction="row"
              gap={2}
              justifyContent="space-around"
              alignItems="center"
            >
              <img src={IMAGES.UploadImage} alt="+" />
              <img src={IMAGES.UploadImage} alt="+" />
            </Stack>
            <Stack direction="row" gap={4} justifyContent="center">
              <Button
                variant="contained"
                sx={{ textTransform: "unset", borderRadius: "30px" }}
              >
                <Typography variant="subtitle1">Map Customer</Typography>
              </Button>
              <Button
                variant="outlined"
                sx={{
                  textTransform: "unset",
                  borderRadius: "30px",
                  minWidth: "20%",
                }}
                onClick={() => handleClose()}
              >
                <Typography variant="subtitle1">Cancel</Typography>
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};
export default MapCustomerModal;
